export enum SettingsBooleanValues {
    IS_ENABLED = "Ja",
    NOT_ENABLED = "Nej",
}
